var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.2666C8.22091 2.2666 8.4 2.44569 8.4 2.6666V8.36758L10.3838 6.38376C10.54 6.22755 10.7933 6.22755 10.9495 6.38376C11.1057 6.53997 11.1057 6.79323 10.9495 6.94944L8.28284 9.61611C8.12663 9.77232 7.87336 9.77232 7.71715 9.61611L5.05049 6.94944C4.89428 6.79323 4.89428 6.53997 5.05049 6.38376C5.2067 6.22755 5.45996 6.22755 5.61617 6.38376L7.6 8.36758V2.6666C7.6 2.44569 7.77908 2.2666 8 2.2666ZM2.26666 13.3333C2.26666 13.1124 2.44575 12.9333 2.66666 12.9333H13.3333C13.5542 12.9333 13.7333 13.1124 13.7333 13.3333C13.7333 13.5542 13.5542 13.7333 13.3333 13.7333H2.66666C2.44575 13.7333 2.26666 13.5542 2.26666 13.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalDown);
export default __webpack_public_path__ + "static/media/final_down.f60ee3d1431a1ae72d1054b28920b3dd.svg";
export { ForwardRef as ReactComponent };